export default __webpack_public_path__ + "static/media/Overview.6753c822.svg";